import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getPersonByIdAsync, getAllPeopleForTasksAsync } from '@application/features/people/peopleThunk';
import { getAllActivityTasksAsync } from '@application/features/task/taskThunk';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { Box, Tab, Tabs, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PageLayout } from '@ui/components/PageLayout';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import FamilyOverview from './components/FamilyOverview';
import PersonProfile from './components/PersonProfile';
import { usePersonDetailStyles } from './usePersonDetailStyles';
import { useRedirectOnCompanyChange } from '@ui/hooks/useRedirectOnCompanyChange';
import { Icon } from '@iconify/react';
import { hasPermission } from '@application/helpers/permission-helper';
import { useSelector } from 'react-redux';
import { Profile2User } from 'iconsax-react';
import { useHelpTopic } from '@ui/contexts';
const PERSON_DETAIL_TAB_TOPICS = ['general', 'family', 'activityTasks', 'eventsAttended', 'tags'];
const PersonDetail = () => {
    useRedirectOnCompanyChange('/people');
    const theme = useTheme();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { id } = useParams();
    const location = useLocation();
    const styles = usePersonDetailStyles();
    const { person } = useAppSelector((state) => state.people);
    const [activeTab, setActiveTab] = useState(0);
    useHelpTopic(PERSON_DETAIL_TAB_TOPICS[activeTab]);
    const loggedInUserPermissions = useSelector((state) => state.auth.currentUser?.permissions || []);
    const canReadTasks = hasPermission(loggedInUserPermissions, 'Permissions.VdkTasks.Read');
    useEffect(() => {
        if (id) {
            dispatch(getPersonByIdAsync(id));
        }
    }, [dispatch, id]);
    // Activate tabs based on URL query parameter ?tab=
    useEffect(() => {
        const search = new URLSearchParams(location.search);
        const tab = (search.get('tab') || '').toLowerCase();
        if (tab === 'general') {
            setActiveTab(0);
        }
        else if (tab === 'family') {
            setActiveTab(1);
        }
        else if (tab === 'activitytasks') {
            setActiveTab(2);
        }
        else if (tab === 'eventsattended') {
            setActiveTab(3);
        }
        else if (tab === 'interests') {
            setActiveTab(4);
        }
    }, [location.search]);
    // Call getAllActivityTasksAsync when activeTab changes to 2 (Activity Tasks)
    useEffect(() => {
        if (canReadTasks && activeTab === 2 && id) {
            dispatch(getAllActivityTasksAsync(id));
            dispatch(getAllPeopleForTasksAsync());
        }
    }, [activeTab, id, dispatch, canReadTasks]);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const handleBackClick = () => {
        navigate('/people');
    };
    return (_jsx(PageLayout, { title: t('people.personDetails'), 
        // secondTitle={t<string>('people.accessAndManageAllPeopleRecordsHere')}
        showLeftIcon: true, leftIcon: _jsx(Profile2User, { variant: 'Outline' }), onBackClick: handleBackClick, showBackButton: true, backIcon: _jsx(Icon, { icon: 'eva:arrow-ios-back-outline', width: 24, height: 24, color: theme.palette.common.white }), showBreadCrumbs: true, showTabs: true, tabs: _jsxs(Tabs, { value: activeTab, onChange: handleTabChange, children: [_jsx(Tab, { label: t('people.general') }), _jsx(Tab, { label: t('people.family') }), _jsx(Tab, { label: t('people.activityTasks') }), _jsx(Tab, { label: t('people.eventsAttended') }), _jsx(Tab, { label: t('settings.tags') })] }), children: _jsx(Box, { sx: styles.container, children: activeTab === 0 ? (
            // General Tab - Show PersonProfile in full width (Grid size 12)
            _jsx(Grid, { container: true, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, children: person && _jsx(PersonProfile, { person: person }) }) })) : (
            // Other Tabs - Show PersonProfile on left and FamilyOverview on right
            _jsx(Grid, { container: true, sx: styles.mainLayout, spacing: 2, children: _jsx(Grid, { size: { xs: 12 }, sx: {
                        ...styles.rightPanel,
                        flexGrow: { lg: 1 },
                        flexBasis: { lg: 0 },
                        minWidth: { lg: 0 }
                    }, children: person && (_jsx(FamilyOverview, { familyMembers: person.personFamily, personId: person.id, activeTab: activeTab })) }) })) }) }));
};
export default PersonDetail;
